<template>
  <v-app>
    <v-container fluid class="pa-0 fill-height d-flex">
      <v-row no-gutters class="fill-height">
        <v-col cols="12" md="4" class="left-side d-flex justify-center">
          <h1 class="white--text main-title">
            Nossa metodologia, seu sucesso!
          </h1>
        </v-col>

        <v-col
          cols="12"
          md="8"
          class="right-side d-flex align-center justify-center"
        >
          <v-card class="form-card" elevation="0">
            <v-card-title class="d-flex align-center justify-center">
              <v-img
                src="@/assets/images/connect/customer/connect-logo.webp"
                contain
                height="250"
              ></v-img>
            </v-card-title>
            <v-card-text style="min-height: 55vh">
              <p class="text-center grey--text mb-2 px-4">
                Para começar a usar a plataforma, precisamos conhecer melhor o
                seu objetivo e o seu nível. Preencha as informações abaixo.
              </p>
              <v-form
                ref="form"
                v-model="valid"
                elevation="0"
                @submit.prevent="nextStep"
              >
                <v-stepper
                  v-model="step"
                  class="stepper"
                  elevation="0"
                  style="max-width: 100%"
                >
                  <v-stepper-header
                    elevation="0"
                    class="d-flex align-center justify-center"
                  >
                    <span class="grey--text poppins">Let's do it!</span>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 1"
                      step="1"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 2"
                      step="2"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 3"
                      step="3"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 4"
                      step="4"
                    ></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items elevation="0">
                    <v-stepper-content step="1">
                      <v-card-text>
                        <h6 class="grey--text">1º Objetivo</h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins"
                            >Qual o seu objetivo para estudar inglês?</strong
                          ><br />
                          <span class="primary900"
                            >(Selecione a opção que melhor descreva a sua
                            situação)</span
                          >
                        </p>
                        <v-row dense>
                          <v-radio-group
                            v-model="details.mainGoal"
                            row
                            :rules="[(v) => !!v || 'Selecione uma opção.']"
                          >
                            <v-col cols="12" md="6">
                              <v-radio
                                label="Profissional"
                                value="PROFESSIONAL"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio
                                label="Comunicação"
                                value="COMMUNICATION"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio label="Viagens" value="TRIPS"></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio label="Outros" value="OTHERS"></v-radio>
                            </v-col>
                          </v-radio-group>
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-card-text>
                              <h6 class="grey--text">2º Acompanhamento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins"
                                  >Qual a sua preferência para estudar
                                  inglês?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 1"
                                  v-model="details.preference"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="Sozinho"
                                    value="ALONE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="Com Professor"
                                    value="WITH_TEACHER"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text>
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins"
                                  >Quantas aulas por semana você gostaria de
                                  ter?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 2"
                                  v-model="details.perWeek"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1"
                                    value="ONCE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="2"
                                    value="TWICE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="3+"
                                    value="THREE_OR_MORE"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins"
                                  >Qual modalidade de aula você deseja
                                  estudar?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="6"
                                  v-for="(goal, index) in types"
                                  :key="index"
                                  class="d-flex align-center justify-start"
                                >
                                  <v-checkbox
                                    v-if="step === 2 && subStep === 3"
                                    v-model="details.formatGoal"
                                    :value="goal.value"
                                    :label="goal.key"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626"
                                  >Selecione ao menos uma opção</small
                                >
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text>
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins"
                                  >Quantas horas por aula?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 4"
                                  v-model="details.availableHours"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1:00"
                                    value="1:00"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="1:30"
                                    value="1:30"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                              <p class="mt-4">
                                <strong class="grey--text">E.</strong>
                                <strong class="primary900 poppins"
                                  >Qual a sua faixa de orçamento mensal?
                                  (opcional)</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col cols="6" md="4">
                                  <v-text-field
                                    v-model.number="details.budgetMin"
                                    label="Mínimo"
                                    prefix="R$"
                                    type="number"
                                    min="0"
                                    dense
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="4">
                                  <v-text-field
                                    v-model.number="details.budgetMax"
                                    label="Máximo"
                                    prefix="R$"
                                    type="number"
                                    min="0"
                                    dense
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1" dense>
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins"
                                  >Em uma escala de 0 a 10, qual é o seu grau de
                                  facilidade em compreender inglês em diversas
                                  situações?</strong
                                >
                              </p>
                              <v-row no-gutters align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Assistir filmes ou séries em inglês
                                    <strong style="color: #32352c">com</strong>
                                    legenda</span
                                  >
                                </v-col>
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    required
                                    row
                                    class="ml-3"
                                    v-model="details.watchWithSub"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Assistir filmes ou séries em inglês
                                    <strong style="color: #32352c">sem</strong>
                                    legenda</span
                                  > </v-col
                                ><v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.watchWithoutSub"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Entender uma conversa em inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.understanding"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4"
                                  ><span class="poppins grey--text"
                                    >Se comunicar em uma conversa em
                                    inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.communication"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Ler um livro ou artigo em inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.reading"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins"
                                  >Onde você geralmente tem contato com o inglês
                                  no seu dia a dia?</strong
                                >
                                <v-row dense class="mt-2">
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(learningWay, index) in learningWays"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      v-if="step === 3 && subStep === 2"
                                      v-model="details.mainContacts"
                                      :value="learningWay"
                                      :label="learningWay"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row dense v-if="displayError">
                                  <small style="color: #ea2626"
                                    >Selecione ao menos uma opção</small
                                  >
                                </v-row>
                              </p>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins"
                                  >Qual é a sua área de atuação
                                  atualmente?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="4"
                                  v-for="(area, index) in currentAreas"
                                  class="d-flex align-center justify-start"
                                  :key="index"
                                >
                                  <v-checkbox
                                    v-model="details.currentAreas"
                                    :value="area"
                                    :label="area"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626"
                                  >Selecione ao menos uma opção</small
                                >
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Objetivos</h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins"
                                  >Você tem alguma meta específica relacionada
                                  ao inglês que gostaria de compartilhar
                                  conosco? (opcional)</strong
                                >
                              </p>
                              <v-col cols="12" md="9">
                                <v-textarea
                                  outlined
                                  solo
                                  placeholder="Digite sua mensagem."
                                  v-model="details.message"
                                  v-if="step === 3 && subStep === 4"
                                  rows="6"
                                ></v-textarea>
                              </v-col>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                      <v-card-text elevation="0">
                        <h6 class="grey--text">4º Disponibilidade</h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins"
                            >Informe TODOS os seus horários disponíveis na
                            semana para realizar as aulas</strong
                          >
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <WeeklyTable
                              ref="weeklyTable"
                              v-if="step === 4"
                              style="width: 100%"
                              :inAHalf="true"
                              :values="available"
                              :perClass="perClass"
                          /></v-col>
                        </v-row>
                        <v-row dense align="center" justify="start">
                          <span v-if="hourAlert" style="color: crimson"
                            >Não são permitidos horários duplicados!</span
                          >
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    v-if="!(step === 1 && subStep === 1)"
                    outlined
                    @click="prevStep"
                    x-large
                    class="grey--text fill-width"
                    >Voltar</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    @click="nextStep"
                    color="#b51f57"
                    x-large
                    class="white--text"
                    :loading="loading"
                    >{{ step === 4 ? "Concluir" : "Avançar" }}</v-btn
                  >
                </div>
              </v-col>
            </v-card-actions>
            <div class="d-flex align-center justify-center">
              <CopyRight />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import customerApi from "@/shared/pitchCustomerApi";
import CopyRight from "@/components/CopyRight.vue";
import WeeklyTable from "@/components/connect/WeeklyTable.vue";

export default {
  name: "CompleteInfo",
  components: { CopyRight, WeeklyTable },
  data() {
    return {
      loading: false,
      valid: false,
      hourAlert: false,
      displayError: false,
      step: 1,
      subStep: 1,
      details: {
        mainGoal: null,
        preference: null,
        perWeek: null,
        formatGoal: [],
        availableHours: null,
        watchWithSub: null,
        watchWithoutSub: null,
        understanding: null,
        communication: null,
        reading: null,
        mainContacts: [],
        currentAreas: [],
        message: null,
        budgetMin: null,
        budgetMax: null,
      },
      available: [{ weekDay: null, from: null, to: null }],
      learningWays: [
        "Música",
        "Filmes e Séries",
        "Livros",
        "Estudos",
        "Trabalho",
        "Outras Formas",
        "Amigos",
        "Redes Sociais",
      ],
      currentAreas: [
        "Estudante",
        "Educação",
        "Comércio",
        "Tecnologia",
        "Saúde",
        "Outros",
      ],
      types: [
        { key: "Individual", value: "INDIVIDUAL" },
        { key: "Dupla", value: "DUO" },
        { key: "Trio", value: "TRIO" },
        { key: "Quarteto", value: "SQUAD" },
      ],
    };
  },
  computed: {
    perClass() {
      return this.details.availableHours === "1:30" ? 90 : 60;
    },
  },
  methods: {
    verifyDuplicated(horarios) {
      const seen = new Set();
      let hasDuplicated = false;
      horarios.forEach((horario) => {
        const chave = `${horario.weekDay}-${horario.from}-${horario.to}`;
        if (seen.has(chave)) {
          hasDuplicated = true;
        }
        seen.add(chave);
      });
      return hasDuplicated;
    },
    nextStep() {
      if (this.step === 4) {
        const items = this.$refs.weeklyTable.getData();
        const validHours = items.filter((h) => h && h.weekDay !== null);
        if (validHours.length && this.verifyDuplicated(validHours)) {
          this.hourAlert = true;
          return;
        }
        this.hourAlert = false;
        this.available = validHours;
        this.submit();
      } else if (this.step === 2 && this.details.preference === "ALONE") {
        // Aluno sozinho: nao precisa de aulas por semana/horas nem formato.
        this.details.perWeek = 0;
        this.details.availableHours = 0;
        this.details.formatGoal = "ALONE";
        this.subStep = 1;
        this.step++;
      } else if (this.step === 2 || this.step === 3) {
        this.nextSubStep();
      } else if (this.$refs.form.validate()) {
        this.step++;
      }
    },
    nextSubStep() {
      if (
        this.step === 2 &&
        this.subStep === 3 &&
        this.details.formatGoal.length === 0
      ) {
        this.displayError = true;
      } else if (
        this.step === 2 &&
        this.subStep < 4 &&
        this.$refs.form.validate()
      ) {
        this.displayError = false;
        this.subStep++;
      } else if (
        this.step === 3 &&
        this.subStep < 4 &&
        this.$refs.form.validate()
      ) {
        if (this.subStep === 2 && this.details.mainContacts.length === 0) {
          this.displayError = true;
          return;
        } else if (
          this.subStep === 3 &&
          this.details.currentAreas.length === 0
        ) {
          this.displayError = true;
          return;
        }
        this.displayError = false;
        this.subStep++;
      } else if (this.$refs.form.validate()) {
        this.displayError = false;
        this.subStep = 1;
        this.step++;
      }
    },
    prevStep() {
      if (this.step === 1) return;
      if (this.step === 2 || this.step === 3 || this.step === 4) {
        return this.previousSubStep();
      }
      this.step--;
    },
    previousSubStep() {
      this.displayError = false;
      if (this.step === 2 && this.subStep === 1) {
        this.step--;
      } else if (this.step === 2 && this.subStep > 1) {
        this.subStep--;
      } else if (this.step === 3 && this.subStep === 1) {
        this.step--;
        // Se for "Sozinho", o passo 2 so teve o subStep 1.
        this.subStep = this.details.preference === "ALONE" ? 1 : 4;
      } else if (this.step === 3 && this.subStep > 1) {
        this.subStep--;
      } else if (this.step === 4) {
        this.step--;
        this.subStep = 4;
      }
    },
    async submit() {
      const details = { ...this.details };
      // Remove orcamento vazio/invalido para nao falhar na validacao numerica.
      ["budgetMin", "budgetMax"].forEach((field) => {
        const value = details[field];
        if (value === "" || value === null || Number.isNaN(Number(value))) {
          delete details[field];
        }
      });

      this.loading = true;
      try {
        await customerApi.completePersonalInfo({
          details,
          available: this.available,
        });

        // Cadastro deixou de estar pendente: atualiza o store e libera a plataforma.
        const user = this.$store.getters.user || {};
        this.$store.commit("SET_USER", { ...user, pendingInfo: false });

        this.$root.$emit("display-alert", {
          text: "Informações salvas com sucesso! Bem-vindo(a).",
          type: 0,
        });
        this.$router.push({ name: "Dashboard" });
      } catch (err) {
        const raw = err?.response?.data?.message || "";
        const message = Array.isArray(raw) ? raw.join(" ") : raw;
        this.$root.$emit("display-alert", {
          text:
            message ||
            "Não foi possível salvar suas informações agora. Tente novamente.",
          type: 1,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}

.left-side {
  background-image: url("../../assets/images/connect/customer/background-min.webp");
  background-size: cover;
  background-position: center;
  color: white;

  h1 {
    margin-top: 15vh;
  }
}

.right-side {
  padding: 24px;
  display: flex;
}

.form-card {
  width: 100%;
  height: 100%;
}

.primary900 {
  color: #6b1233;
}

.primary700 {
  color: #b51f57;
}

strong {
  font-size: 16px;
}
</style>
